export default {

  


    state: {
        userName:"",//用户名
        identity:{},
    },
    mutations: {       
        handelName(state,val){
            state.userName =val    
           console.log("存名字",state.userName);
           
        },
        handelIdentity(state,val){
            state.identity =val
            console.log("存权限",state.identity);
        }
    },
    actions: {  
  
    },  
   

  
}